/**
 * Keep logic aligned with `src/utils/fujifilmProductCodes.ts` (server).
 */

export function isFujifilmBrand(brand?: string, brandId?: string): boolean {
  if (brandId && String(brandId).toLowerCase().trim() === 'fujifilm') return true;
  if (brand && /^fujifilm$/i.test(String(brand).trim())) return true;
  return false;
}

export function isFujifilmNumericCatalogCode(value: string | undefined | null): boolean {
  if (value == null) return false;
  return /^\d{8,}$/.test(String(value).trim());
}

export function fujifilmCatalogGap(brand?: string, brandId?: string, sku?: string, mpn?: string): boolean {
  if (!isFujifilmBrand(brand, brandId)) return false;
  const s = String(sku || '').trim();
  const m = String(mpn || '').trim();
  if (!isFujifilmNumericCatalogCode(s)) return true;
  if (m && !isFujifilmNumericCatalogCode(m)) return true;
  if (isFujifilmNumericCatalogCode(s) && m && isFujifilmNumericCatalogCode(m) && s !== m) return true;
  if (isFujifilmNumericCatalogCode(s) && !m) return true;
  return false;
}
